var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.293 3.29279C12.1055 3.48031 12.0002 3.73462 12.0002 3.99979C12.0002 4.26495 12.1055 4.51926 12.293 4.70679L14.586 6.99979H8.99997C7.14345 6.99979 5.36298 7.73728 4.05022 9.05004C2.73747 10.3628 1.99997 12.1433 1.99997 13.9998V15.9998C1.99997 16.265 2.10533 16.5194 2.29286 16.7069C2.4804 16.8944 2.73475 16.9998 2.99997 16.9998C3.26519 16.9998 3.51954 16.8944 3.70708 16.7069C3.89461 16.5194 3.99997 16.265 3.99997 15.9998V13.9998C3.99997 12.6737 4.52675 11.4019 5.46444 10.4643C6.40212 9.52657 7.67389 8.99979 8.99997 8.99979H14.586L12.293 11.2928C12.1975 11.385 12.1213 11.4954 12.0689 11.6174C12.0165 11.7394 11.9889 11.8706 11.9877 12.0034C11.9866 12.1362 12.0119 12.2678 12.0621 12.3907C12.1124 12.5136 12.1867 12.6253 12.2806 12.7192C12.3745 12.8131 12.4861 12.8873 12.609 12.9376C12.7319 12.9879 12.8636 13.0132 12.9964 13.012C13.1291 13.0109 13.2604 12.9833 13.3824 12.9309C13.5044 12.8785 13.6147 12.8023 13.707 12.7068L17.707 8.70679C17.8944 8.51926 17.9998 8.26495 17.9998 7.99979C17.9998 7.73462 17.8944 7.48031 17.707 7.29279L13.707 3.29279C13.5194 3.10532 13.2651 3 13 3C12.7348 3 12.4805 3.10532 12.293 3.29279Z",
    fill: "#743BBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.bab64c176fe0471e52053398eb282067.svg";
export { ForwardRef as ReactComponent };